import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {editProductService} from "../../../Services/Product/ProductServiceService";
import LinearProgress from '@mui/material/LinearProgress';
import {getUnits, getCurrencies, getBanks} from '../../../Util/SiteDataUtil';
import {editBackAccount} from "../../../Services/Company/BankAccountService";
import BankAccountForm from "../../../Components/Forms/Pages/Company/BankAccountForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}, 'publicName': {required: true}, 'publicInoName': {required: true}, 'description': {required: true},
    'price': {required: true}, 'tax': {required: true}, 'currency': {required: true}, 'unit': {required: true},
}

const EditBankAccount = (props) => {

    const siteData = useSelector((state) => state.siteData)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);


    useEffect(() => {
        setDrawerTitle(strings.pages.finance.bankAccount.editBankAccount.pageTitle);
    });

    const onSubmit = (data) => {

        setShowLoader(true);

        editBackAccount(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <BankAccountForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                currencies={getCurrencies(siteData)}
                banks={ getBanks(siteData) }
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditBankAccount;